<script>
import GuestDocumentationMixin from '@/mixins/guestdocumentation'
import { helpers } from '@/helpers.js'

export default {
  name: 'GuestDomentationContiki',
  mixins: [ GuestDocumentationMixin ],
  computed: {},
  methods: {
    isInvalidContent (field = '') {
      return helpers.isInvalidContent(field)
    },
    scrollMeTo (refName) {
      var element = document.getElementById(refName)
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      })
    },
    scrollMeDay (dd) {
      var element = document.getElementById(dd)
      var modal = document.getElementById('modal-fullscreen')
      modal.scrollTo({
        top: element.offsetTop,
        behavior: 'smooth'
      })
    },
    printPage () {
      window.print()
    }
  }
}
</script>

<style lang="scss" scoped>
@import './font-fontawesome.scss';
@import './bootstrap.scss';
@import './main.scss';
@import './style-1.scss';
@import './print.scss';
</style>
<template>
  <div id="menu" class="body-page fp-viewing-home body" :class="{ 'modal-open': isModalToggle }">
    <!-- BEGIN OF site header Menu -->
    <header class="page-header navbar page-header-drawer menu-right logo-left topmenu-right animated slow fadeIn">
     <div class="menu-itinerary row">
        <div class="col-md-12 col-12">
        <div class="container-menu paddig-container">
          <div class="cover-logo">
            <a class="navbar-brand" href="#">
              <span class="logo">
                <img class="logo-itinerary" src="/guestdocumentation/contiki/img/logo.png" alt="Logo">
              </span>
            </a>
          </div>
          <!-- Begin of menu icon toggler -->
          <button class="navbar-toggler site-menu-icon" id="navMenuIcon" :class="{ 'menu-visible': isMenuToggle }" @click="toggleMenu">
            <span class="menu-icon menu-icon-line" :class="{ 'menu-visible': isMenuToggle }">
              <span class="bars">
                <span class="bar1"></span>
                <span class="bar2"></span>
                <span class="bar3"></span>
              </span>
            </span>
          </button>
        </div>
        </div>
      </div>

      <div class="all-menu-wrapper" id="navbarMenu" :class="{ 'menu-visible': isMenuToggle }">
        <nav class="navbar-mainmenu">
          <div class="mainmenu-bg" @click="toggleMenu"></div>
          <div class="mainmenu-content">
          <img src="/guestdocumentation/contiki/img/logo.png" alt="Logo" class="light-logo menu-logo">
          <div class="divider-menu">
          </div>
            <ul class="navbar-nav">
              <li class="nav-item">
                <a class="nav-link" href="#home" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('home')">Home
                  <span class="sr-only">(current)</span>
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#introduction" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('introduction')">Introduction</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#itinerary" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('itinerary')">Itinerary</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#map" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('map')">Map</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#hotel" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('hotel')">Hotel List</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#freetime" :class="{ 'menu-visible': isMenuToggle }" @click.prevent="menuScrollTo('freetime')">Free Time Add-ons</a>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <!-- END OF site header Menu-->

    <!-- BEGIN OF page main content -->
    <main class="page-main main-anim scrollpage-container" id="mainpage">
      <div
        id="home"
        class="backgroundHome section section-home fullscreen-md main-home section-center content-black bg-level-1"
        data-section="home"
        :style="[ firstOpporunityBackgroundImage != ''
                  ? {
                    backgroundImage: `url('${getParsedImageUrl(
                      firstOpporunityBackgroundImage
                    )}')`
                  } : { backgroundImage: 'url(/guestdocumentation/contiki/img/bg-style-1.jpg)'}]">

        <div class="overlay-home"></div>
        <div class="section-wrapper animated delay-1s slow fadeIn home-flex">
          <div class="section-content anim">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="cover-header-description text-center">
                  <div class="cover-slider-description">
                   <div class="cover-calendar-location">
                      <h1 class="cover-header-description-title1">
                            <span>
                                <i class="icon fa fa-calendar"></i>
                                <span v-if="d && d.itineraries">{{ d.itineraries.fromitinerary | custom-date }}</span>
                                <i class="fa fa-arrow-right ml-3 mr-2"></i>
                            </span>
                            <span class="date-block">
                              <i class="icon fa fa-calendar"></i>
                              <span v-if="d && d.itineraries">{{ d.itineraries.toitinerary | custom-date }}
                            </span>
                        </span>
                        <span class="ml-3 location-cover" v-if="Array.isArray(d.itineraries.locations_visited) == true">
                            <i class="fa fa-map-marker"></i>
                            <span v-if="d && d.itineraries && d.itineraries.locations_visited && Array.isArray(d.itineraries.locations_visited)">{{ d.itineraries.locations_visited | custom-join('name') }}
                            </span>
                        </span>
                      </h1>
                    </div>
                    <div class="cover-header-description-title2">
                      TRIP INFORMATION
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.itineraries">
                        <span>{{ d.itineraries.titleitinerary }}</span>
                    </div>
                    <div class="cover-header-description-title3" v-if="d && d.properties_opportunity && d.reference_number">
                        <small> {{ d.reference_number }}</small>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <footer class="section-footer scrolldown">
            <a class="down" @click="scrollMeTo('introduction')">
              <span class="icon"></span>
              <span class="txt">INTRODUCTION</span>
            </a>
          </footer>
        </div>
      </div>

      <!-- Begin of grid list section -->
      <div class="section fl-porto bg-level-1" data-section="introduction" id="introduction">
        <div class="section-wrapper with-margin">
          <div class="row">
            <div class="col-12 col-md-12 text-left ">
              <div class="title-desc anim-4 padding-container2"><button class="button_print btn btn-radius btn-green" @click="printPage"><i class="fa fa-print"></i>Print</button></div>
                <!--PRINT: INTRODUCTION-->
                   <table id="print-header" class="print-only">
                      <tbody>
                         <tr>
                            <td width="70%">
                               <h1 class="title_trip_info">TRIP<br> INFORMATION</h1>
                            </td>
                            <td width="10%"></td>
                            <td class="total-value" width="20%">
                               <div id="logo" class="logo_print">
                                <img class="light-logo" src="/guestdocumentation/contiki/img/logo.png" alt="Logo" width="240">
                               </div>
                            </td>
                         </tr>
                         <tr>
                            <td width="70%" v-if="d && d.itineraries">
                              <div class="border-trip-name">
                               <h4>{{ d.itineraries.titleitinerary }}</h4>
                              </div>
                            </td>
                            <td width="10%"></td>
                            <td class="trip-code-section" width="20%">
                              <div class="print_info_it">
                                <p id="trip-code-number-section" v-if="d && d.properties_opportunity && d.reference_number">TRIP CODE<strong id="trip-code">{{ d.reference_number }}</strong></p>
                                <p id="trip-date-section" v-if="d && d.itineraries">TRIP DATE<strong id="trip-code">{{ d.itineraries.fromitinerary | custom-date }}</strong></p>
                               </div>
                            </td>
                         </tr>
                      </tbody>
                   </table>
                 <!--PRINT: INTRODUCTION-->
              <div
                class="title-desc anim-4 paddig-container letter-information"
                v-html="d.guest_documentation.introduction">
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of grid list section -->
      <div class="section bg-level-2" data-section="itinerary" id="itinerary">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="section-tittle">
              <div class="cover-header-description-title2 title-sections scrolled mb-4 text-center">Itinerary</div>
              <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Your Travel Itinerary</h1></div>
                <div class="cover-header-description-title3 text-center" v-if="d && d.itineraries">
                    {{ d.itineraries.titleitinerary }}
                </div>
            </div>
          </div>
        </div>
          <!--PRINT: YOUR TRAVEL ITINERARY-->
          <ul id="days-box" class="print-only print__itinerary">
            <li :id="`day${index}`" v-for="(day, index) in d.itineraries.days" :key="index" class="print__itinerary--item">
                <h4 class="title-day-date">DAY {{ index + 1}} <span class="title-day" v-html="day.title"></span></h4>
                <p class="dl-print">
                  <span v-if="day" class="date">{{ day.startdate | custom-date }}</span> / <span class="location"
                    v-if="day && day.locations && Array.isArray(day.locations)"> <span>{{ day.locations | custom-join('name')
                      }}</span>
                  </span>
                </p>
                <p v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                <p v-if="day.meals">
                  <strong class="mr-1">MEAL(S):</strong>
                  <span>{{ day.meals | custom-join('mealsday') }}</span>
                </p>
                <p v-if="day.accommodation">
                  <strong class="mr-1">ACCOMMODATION:</strong>
                  <span>{{ day.accommodation}}</span>
                </p>
            </li>
          </ul>
          <!--PRINT: YOUR TRAVEL ITINERARY-->
      </div>
      <div class="row row-random grid-media-aside-text fade-3 no-print" data-section="itinerary-days" id="itinerary-days">
          <div class="col-md-6 border-card" v-for="(day, index) in d.itineraries.days" :key="index" @click="dayScrollTo(index)">
            <div class="card gallery-day" data-toggle="modal" data-target="#modal-fullscreen">
              <img v-if="day.url_image_1200_725" :src="day.url_image_1200_725"/>
              <img v-if="!day.url_image_1200_725" src="/guestdocumentation/contiki/img/day-img.jpg"/>
              <div class="info text-center">
                <p class="day_position text-uppercase">day {{ day.startday }}</p>
                <h1 class="title-day" v-html="day.title"></h1>
                <p>
                  <i class="icon fa fa-calendar mr-2"></i>
                  <span v-if="day">{{ day.startdate | custom-date }}</span>
                </p>
                <p v-if="day && day.locations && Array.isArray(day.locations)" class="location mt-2">
                  <i class="fa fa-map-marker mr-2"></i>
                  <span >{{ day.locations | custom-join('name') }}</span>
                </p>
                  <button
                    class="btn mt-3 btn-radius btn-white">
                    <div class="text">See this day</div>
                  </button>
              </div>
            </div>
          </div>
      </div>
      <!-- End of grid list section -->

      <!-- Begin of map section -->
      <div class="section section-register bg-level-1 no-print" data-section="map" id="map">
        <div class="section-wrapper with-margin">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-center">
                <div class="title-desc content-white">
                  <h2 class="title-sections">Map</h2>
                  <p class="mb-5 mt-3">Map route is to be used as a guide for illustration purposes only, and does not represent the exact path taken.</p>
                </div>
                <div class="section-maps">
                  <Map :locations="locationsVisited" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Begin of hotel list section -->
      <div class="section fullscreen-md-off bg-level-2 no-footer" data-section="hotel" id="hotel">
        <div class="section-wrapper with-margin section-hotel">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12 text-left">
                <div class="section-tittle text-center">
                  <div class="cover-header-description-title2 title-sections scrolled">Hotel List</div>
                </div>
                <div class="table_pricing mb-4">
                  <div class="row">
                    <div class="col-12 col-md-12 anim">
                      <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Hotel List</h1></div>
                      <div class="section-column amount-price">
                          <div v-html="d.guest_documentation.hotel_list"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Begin of free time addons section -->
      <div class="section fullscreen-md-off bg-level-1 no-footer content-white" data-section="freetime" id="freetime" v-if="!isInvalidContent(d.guest_documentation.optional_experience)">
        <div class="section-wrapper with-margin section-hotel">
          <div class="section-content anim paddig-container">
            <div class="row">
              <div class="col-12 col-md-12">
                <div class="section-tittle text-center content-white">
                  <div class="title-sections scrolled content-white">Free Time Add-ons</div>
                </div>
                <div class="table_pricing mb-4">
                  <div class="row">
                    <div class="col-12 col-md-12 anim">
                      <div class="title-print"><h1 class="display-5 anim-2 h2 mb-4">Free Time Add-ons</h1></div>
                      <div>
                          <div v-html="d.guest_documentation.optional_experience"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer>
        <div class="section-wrapper padding-footer">
          <div class="powered-by-text">
            Powered by<br>
            <img src="/guestdocumentation/contiki/img/logo-itp.png" width="80">
          </div>
          <div class="detail">All rights reserved: ©Global Encounters™ 1999 - {{new Date().getFullYear()}}</div>
        </div>
      </footer>
    </main>
    <!-- Modal Fullscreen -- DAYS-->
    <div
      class="modal modal-fullscreen fade modalDays animated fadeIn"
      id="modal-fullscreen" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
      :class="{ 'show': isModalToggle }"
      :style="{ display: 'block', paddingRight: '16px' }"
      v-show="isModalToggle">
      <div class="section-header">
        <img class="light-logo" src="/guestdocumentation/contiki/img/logo.png" alt="Logo">
        <button
          type="button" class="close" data-dismiss="modal" aria-hidden="true"
          @click="toggleModal"><i class="fa fa-times"></i></button>
      </div>
      <div class="modal-dialog ">
        <div class="modal-content  ">
          <div class="modal-body">

            <div
              class="col-md-12 p-0 section-day p active"
              :id="`itinerary_day${index}`"
              v-for="(day, index) in d.itineraries.days" :key="index">
              <div class="row">
                <div class="col-md-6 cover-image">
                  <img v-if="day.url_image_1600_900" :src="day.url_image_1600_900"/>
                  <img v-if="!day.url_image_1600_900" src="/guestdocumentation/contiki/img/day-img.jpg"/>
                </div>
                <div class="col-md-6 section-text pl-0">
                  <div class="align-vcenter text-center">
                    <h1>Day {{ index + 1}}</h1>
                    <p class="subtittle" v-html="day.title"></p>
                    <p class="date">
                      <i class="icon fa fa-calendar mr-1"></i>
                      <span v-if="day">{{ day.startdate | custom-date }}</span>
                    </p>
                    <p class="location mt-2" v-if="day && day.locations && Array.isArray(day.locations)" >
                      <i class="fa fa-map-marker mr-2"></i>
                      <span>{{ day.locations | custom-join('name') }}</span>
                    </p>
                    <p class="day-information" v-if="day && day.textday && day.textday[0] && day.textday[0].textday" v-html="day.textday[0].textday"></p>
                    <p v-if="day.meals">
                      <strong class="mr-1">MEAL(S):</strong>
                      <span>{{ day.meals | custom-join('mealsday') }}</span>
                    </p>
                    <p v-if="day.accommodation">
                      <strong class="mr-1">ACCOMMODATION:</strong>
                      <span v-html="day.accommodation"></span>
                    </p>
                  </div>
                  <footer class="section-footer scrolldown nextday"
                  v-if="index != Object.keys(d.itineraries.days).length - 1">
                    <a class="down" @click="scrollMeDay(`itinerary_day${index+1}`)">
                      <span class="txt">DAY {{ Number(day.startday) + 1 }}</span>
                    </a>
                  </footer>
                  <footer class="section-footer scrolldown nextday" v-else>
                    <a class="down" @click="scrollMeDay('day0')">
                      <span class="txt">DAY 1</span>
                    </a>
                  </footer>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
